export const EventOptions = [
    { key: 1, label: "Bajaj Finserv Warranty Status", value: "Bajaj Finserv Warranty Status", is_active: true },
    { key: 2, label: "Closing Stock Data", value: "Closing Stock Data", is_active: true  },

    // dummy events
    // { key: 3, label: "Bajaj Finserv: Frame Number - Warranty Already Registered.", value: "Bajaj Finserv: Frame Number - Warranty Already Registered.", is_active: true  },
    // { key: 4, label: "Closing Stock Report - E-Bikes | 2025-06-22", value: "Closing Stock Report - E-Bikes | 2025-06-22", is_active: true  },
    // { key: 5, label: "Bajaj Finserv: Product code mapping error.", value: "Bajaj Finserv: Product code mapping error.", is_active: true  },
    // { key: 6, label: "Bajaj Finserv: Frame Number not found error.", value: "Bajaj Finserv: Frame Number not found error.", is_active: true  },
    // { key: 7, label: "Bajaj Finserv: Franchise code mapping error.", value: "Bajaj Finserv: Franchise code mapping error.", is_active: true  },
];

// mail listing
export const MailListing  = {
    "list": [
        {
            "id": "1",
            "et_subject": "Notification regarding warranty status",
            "et_event": "Bajaj Finserv: Frame Number - Warranty Already Registered.",
            "et_to": "user1@example.com",
            "et_cc": "cc1@example.com",
            "et_body": "The frame number you provided has already been registered for warranty.",
            "is_active": true
        },
        {
            "id": "2",
            "et_subject": "Weekly Stock Report",
            "et_event": "Closing Stock Report - E-Bikes | 2025-06-22",
            "et_to": "user2@example.com",
            "et_cc": "",
            "et_body": "Attached is the weekly closing stock report for e-bikes.",
            "is_active": true
        },
        {
            "id": "3",
            "et_subject": "Mapping Error Found",
            "et_event": "Bajaj Finserv: Product code mapping error.",
            "et_to": "user3@example.com",
            "et_cc": "cc2@example.com",
            "et_body": "There was a problem mapping the product code. Please review.",
            "is_active": false
        },
        {
            "id": "4",
            "et_subject": "Frame Number Missing",
            "et_event": "Bajaj Finserv: Frame Number not found error.",
            "et_to": "user4@example.com",
            "et_cc": "",
            "et_body": "The frame number provided was not found in our records.",
            "is_active": true
        },
        {
            "id": "5",
            "et_subject": "Franchise Code Issue",
            "et_event": "Bajaj Finserv: Franchise code mapping error.",
            "et_to": "user5@example.com",
            "et_cc": "cc3@example.com",
            "et_body": "There is a mismatch in franchise code mapping.",
            "is_active": true
        },
        {
            "id": "6",
            "et_subject": "Duplicate Warranty Registration",
            "et_event": "Bajaj Finserv: Frame Number - Warranty Already Registered.",
            "et_to": "user6@example.com",
            "et_cc": "cc1@example.com",
            "et_body": "Duplicate warranty detected for submitted frame number.",
            "is_active": false
        },
        {
            "id": "7",
            "et_subject": "Notification regarding warranty status",
            "et_event": "Bajaj Finserv: Frame Number - Warranty Already Registered.",
            "et_to": "user7@example.com",
            "et_cc": "cc4@example.com",
            "et_body": "The frame number has already been used for warranty.",
            "is_active": true
        },
        {
            "id": "8",
            "et_subject": "Weekly Stock Report",
            "et_event": "Closing Stock Report - E-Bikes | 2025-06-22",
            "et_to": "user8@example.com",
            "et_cc": "",
            "et_body": "Attached is the weekly closing stock report for e-bikes.",
            "is_active": false
        },
        {
            "id": "9",
            "et_subject": "Mapping Error Found",
            "et_event": "Bajaj Finserv: Product code mapping error.",
            "et_to": "user9@example.com",
            "et_cc": "cc5@example.com",
            "et_body": "A product code mapping issue has been detected.",
            "is_active": true
        },
        {
            "id": "10",
            "et_subject": "Frame Number Not Found",
            "et_event": "Bajaj Finserv: Frame Number not found error.",
            "et_to": "user10@example.com",
            "et_cc": "",
            "et_body": "Frame number not available in the system.",
            "is_active": true
        },
        {
            "id": "11",
            "et_subject": "Franchise Code Issue",
            "et_event": "Bajaj Finserv: Franchise code mapping error.",
            "et_to": "user11@example.com",
            "et_cc": "cc6@example.com",
            "et_body": "Franchise code not mapped correctly.",
            "is_active": false
        },
        {
            "id": "12",
            "et_subject": "Warranty Conflict Detected",
            "et_event": "Bajaj Finserv: Frame Number - Warranty Already Registered.",
            "et_to": "user12@example.com",
            "et_cc": "",
            "et_body": "Warranty registration failed due to duplication.",
            "is_active": true
        },
        {
            "id": "13",
            "et_subject": "Final Warning - Warranty Issue",
            "et_event": "Bajaj Finserv: Frame Number - Warranty Already Registered.",
            "et_to": "user30@example.com",
            "et_cc": "cc9@example.com",
            "et_body": "Final notice: the frame number has been previously registered.",
            "is_active": true
        }
    ],
    pagination: {
        total_records: 13,
        record_limit: 10,
        current_page: 1,
    },
};

// get mail details
export function GetMailListing(id) {
    let idswisedetails = MailListing.list.find((elm) => elm?.id === id);
    return idswisedetails;
};
